module.exports = __webpack_public_path__ + "static/speakers-2779c1bab683a30418752e2ebaa7f400.png";